import { FrameHealthStatus } from 'features/Health/components/FrameHealthChart/types/frameHealthStatus';
import {
  CUSTOM_WARNING,
  PALETTE_BLUE_400,
  PALETTE_ERROR_MAIN,
  PALETTE_NEUTRAL_LIGHT,
  PALETTE_WARNING_MAIN,
} from 'utils/colours';

export const frameHealthStatusValues: FrameHealthStatus[] = [
  {
    status: 'mia',
    statusFilter: 'MIA',
    displayLabel: 'MIA',
    color: PALETTE_ERROR_MAIN,
  },
  {
    status: 'inError',
    statusFilter: 'IN_ERROR',
    displayLabel: 'Error',
    color: PALETTE_WARNING_MAIN,
  },
  {
    status: 'lowDelivery',
    statusFilter: 'LOW_DELIVERY',
    displayLabel: 'Low Delivery',
    color: CUSTOM_WARNING,
  },
  {
    status: 'ok',
    statusFilter: 'OK',
    displayLabel: 'OK',
    color: PALETTE_BLUE_400,
  },
  {
    status: 'deactivated',
    statusFilter: 'DEACTIVATED',
    displayLabel: 'Deactivated',
    color: PALETTE_NEUTRAL_LIGHT,
  },
];
